import { Reveal } from "@/lib/reveal";
import entranceImage from "@/assets/she-is-not.jpg";

export function Journal() {
  return (
    <section
      id="journal"
      data-testid="journal-section"
      aria-labelledby="journal-heading"
      className="relative py-24 sm:py-32"
    >
      <div className="mx-auto max-w-3xl px-6 sm:px-8">
        <Reveal>
          <figure className="border border-gold/40">
            <img
              src={entranceImage}
              alt="Maya, a character in The Inkwell's story, standing on an empty road beneath towering indigo storm clouds — she is not where she began"
              data-testid="journal-entrance-image"
              loading="lazy"
              width={1102}
              height={1427}
              className="max-h-[72vh] w-full object-cover object-center"
            />
            <figcaption className="px-8 py-12 text-center sm:px-14 sm:py-14">
              <h2
                id="journal-heading"
                className="font-serif text-3xl font-light leading-tight tracking-tight text-ivory sm:text-4xl"
              >
                The Inkwell Journal
              </h2>
              <p className="mt-4 font-serif text-xl font-light italic text-stone">
                A space for what lives within.
              </p>
              <p className="mx-auto mt-5 max-w-sm text-sm leading-relaxed text-stone/75">
                30 pages of quotations, reflection prompts, and room to write.
              </p>
              <p className="mt-3 font-mono text-[10px] tracking-[0.25em] uppercase text-gold/80">
                Free to download
              </p>
              <a
                href="/the-inkwell-journal.pdf"
                download="The-Inkwell-Journal.pdf"
                data-testid="journal-download-button"
                aria-label="Download The Inkwell Journal (PDF, downloads directly)"
                className="mt-8 inline-block rounded-sm border border-gold px-8 py-3.5 font-mono text-xs tracking-[0.25em] uppercase text-gold transition-colors duration-500 hover:bg-gold hover:text-inkblack"
              >
                Download the Journal
              </a>
            </figcaption>
          </figure>
        </Reveal>
      </div>
    </section>
  );
}
